// extracted by mini-css-extract-plugin
module.exports = {"title":"newsdata_title__2RYux","author":"newsdata_author__GTTbd","des":"newsdata_des__1Ci5Z","footer":"newsdata_footer__2tM-S"};